import { ROUTES } from '../Config';

const routesToHide = [`/${ROUTES.ADMIN_FEEDBACK}`, ROUTES.DATA_ANALYSIS];

export const useShowUserInfo = () => {
  return !routesToHide.includes(window.location.pathname);
};
